module.exports = __webpack_public_path__ + "img/classify-item6.0dc4bd31.png";